import { createContext } from 'react';
import type { BoardMemberRecord } from '../types';

export interface BoardMemberContextValue {
  isLoading: boolean;
  syncError: string | null;
  storageMode: 'bliss' | 'local';
  members: BoardMemberRecord[];
  publicMembers: BoardMemberRecord[];
  saveMember: (member: BoardMemberRecord) => Promise<BoardMemberRecord>;
  deleteMember: (memberId: string) => Promise<void>;
}

export const BoardMemberContext = createContext<BoardMemberContextValue | null>(null);
